import React from 'react'

import { Button, Fieldset, Toasts, Tooltip } from '@fourthwall/components'

import type { App } from '../../types'
import * as S from './AdminTab.styled'
import { useChangePlatformAppStatus } from './hooks/useChangePlatformAppStatus'
import { usePublishPlatformApp } from './hooks/usePublishPlatformApp'
import { useRefreshPlatformApp } from './hooks/useRefreshPlatformApp'
import { useUnpublishPlatformApp } from './hooks/useUnpublishPlatformApp'

type AdminTabProps = {
  app: App
}

export const AdminTab = ({ app }: AdminTabProps) => {
  const { publishPlatformApp, isLoading: isPublishLoading } = usePublishPlatformApp()
  const { unpublishPlatformApp, isLoading: isUnpublishLoading } = useUnpublishPlatformApp()
  const { refreshPlatformApp, isLoading: isRefreshLoading } = useRefreshPlatformApp()
  const { changePlatformAppStatus, isLoading: isChangeLoading } = useChangePlatformAppStatus()

  const handlePublish = () => {
    Toasts.notify('Published', { type: 'success' })
    publishPlatformApp([{ clientId: app.id }])
  }

  const handleUnpublish = () => {
    Toasts.notify('Unpublished', { type: 'info' })
    unpublishPlatformApp([{ clientId: app.id }])
  }

  const handleCommunity = () => {
    Toasts.notify('Submitted', { type: 'info' })
    changePlatformAppStatus([{ clientId: app.id, status: 'COMMUNITY' }])
  }

  const handleRefresh = () => {
    Toasts.notify('Syncing app data to Shop Renderer', { type: 'info' })
    refreshPlatformApp([{ clientId: app.id }])
  }

  return (
    <S.Container>
      <Fieldset>
        <Fieldset.Row>
          <Fieldset.Item>
            <S.SectionLabel>App Status</S.SectionLabel>
            <S.StatusInfo>
              Current status: <strong>{app.status}</strong>
            </S.StatusInfo>
          </Fieldset.Item>
        </Fieldset.Row>

        <Fieldset.Row>
          <Fieldset.Item>
            <S.ButtonContainer>
              {app.status !== 'DRAFT' ? (
                <Button
                  label="Unpublish"
                  appearance="destructive"
                  onClick={handleUnpublish}
                  loading={isUnpublishLoading}
                />
              ) : (
                <div />
              )}

              {app.status !== 'PUBLISHED' ? (
                <Button
                  label="Publish"
                  appearance="primary"
                  onClick={handlePublish}
                  loading={isPublishLoading}
                />
              ) : (
                <div />
              )}

              {app.status !== 'COMMUNITY' ? (
                <Button
                  label="Community"
                  appearance="primary"
                  onClick={handleCommunity}
                  loading={isChangeLoading}
                />
              ) : (
                <div />
              )}

              <Tooltip
                reference={
                  <Button
                    label="Sync"
                    appearance="secondary"
                    onClick={handleRefresh}
                    loading={isRefreshLoading}
                  />
                }
              >
                Sync app data to Shop Renderer
              </Tooltip>
            </S.ButtonContainer>
          </Fieldset.Item>
        </Fieldset.Row>
      </Fieldset>
    </S.Container>
  )
}
